<template>
<div>
    <vue-glide>
        <vue-glide-slide><img src="/images/testimonials/1.gif" alt="testimonial 1" @click="openImage(1)"></vue-glide-slide>
        <vue-glide-slide><img src="/images/testimonials/2.gif" alt="testimonial 2" @click="openImage(2)"></vue-glide-slide>
        <vue-glide-slide><img src="/images/testimonials/3.gif" alt="testimonial 3" @click="openImage(3)"></vue-glide-slide>
        <vue-glide-slide><img src="/images/testimonials/4.gif" alt="testimonial 4" @click="openImage(4)"></vue-glide-slide>
        <vue-glide-slide><img src="/images/testimonials/5.gif" alt="testimonial 5" @click="openImage(5)"></vue-glide-slide>
        <vue-glide-slide><img src="/images/testimonials/6.gif" alt="testimonial 6" @click="openImage(6)"></vue-glide-slide>
        <vue-glide-slide><img src="/images/testimonials/7.gif" alt="testimonial 7" @click="openImage(7)"></vue-glide-slide>
        <vue-glide-slide><img src="/images/testimonials/8.gif" alt="testimonial 8" @click="openImage(8)"></vue-glide-slide>
        <template slot="control">
            <button data-glide-dir="<" class="text-white text-center text-lg mx-8 mt-4 mb-2 opacity-50 hover:opacity-100">
                <i class="fa fa-arrow-left px-2"></i>
                Previous
            </button>
            <button data-glide-dir=">" class="text-white text-center text-lg mx-8 mt-4 mb-2 opacity-50 hover:opacity-100">
                Next
                <i class="fa fa-arrow-right px-2"></i>
            </button>
        </template>
    </vue-glide>
    <modal name="imagezoom"
        :width="780"
        height="auto"
    >
        <img :src="selectedimage" alt="">
    </modal>
</div>

</template>
<style>
.glide__slide { height: auto !important; }
</style>
<script>
import VueGlide from 'vue-glide-js/src/components/Glide.vue'
import VueGlideSlide from 'vue-glide-js/src/components/GlideSlide.vue'

export default {
    data() {
        return {
            imageIndex: 1
        }
    },

    computed: {
        selectedimage() {
            return '/images/testimonials/' + this.imageIndex + '.gif'
        }
    },

    methods: {
        openImage(index) {
            this.imageIndex = index
            this.$modal.show('imagezoom')
        }
    },

    components: {
        [VueGlide.name]: VueGlide,
        [VueGlideSlide.name]: VueGlideSlide
    }
}
</script>
